import {
    ContentBlockMetadataRestDto,
    MultilingualMax50FieldRestDto,
    SimpleDocumentContentRestDto
} from "@/api/pharma-cms-content-block/models";
import {StatusEnum} from "@/api/enums/status-enum";
import {MultilingualRestDtoModel} from "@/models/MultilingualRestDtoModel";

export class SimpleDocumentContentRestDtoModel implements SimpleDocumentContentRestDto {
    status_code: string;
    document_key: MultilingualMax50FieldRestDto;
    cb_metadata: ContentBlockMetadataRestDto | null;

    constructor(cb_metadata: ContentBlockMetadataRestDto | null, content: MultilingualMax50FieldRestDto, status_code: string) {
        this.cb_metadata = cb_metadata;
        this.document_key = content;
        this.status_code = status_code;
    }

    public static createWithDefaults(): SimpleDocumentContentRestDtoModel {
        return new this(
            null,
            MultilingualRestDtoModel.createWithDefaults(),
            StatusEnum.PUBLISHED
        );
    }
}
